import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const HELP_PATHNAME = `/help/:lang?/:page?`;

export const HelpLoadable = loadable(async () => import('./help.view'), {
  fallback: <FullPageLoading />,
});
